<template>
    <ModalComponent
        :name="'borrar-' + frecuencia.id"
        :title="'¿Seguro que quieres borrar el categoría: ' + frecuencia.name + '?'"
        v-on:close="() => close()"
    >
        <div class="row">
            <div class="col-12">
                <h2>Datos de la frecuencia</h2>
            </div>
            <div class="col-12">
                <ul class="list-group list-group-unbordered mb-3">
                    <li class="list-group-item">
                        <b>Nombre:</b> {{ frecuencia.name }}
                    </li>
                </ul>
            </div>
            <div class="col-12 text-center">
                <h1 class="font-weight-bold">¿BORRAR FRECUENCIA?</h1>
            </div>
            <div class="col-12 text-center">
                <Button type="button" name="button" @click="borrarFrecuencia">SI, BORRAR</Button>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['frecuencia', 'lista_id'],
        data() {
            return {
                loading: false
            }
        },
        methods: {
            close() {
                this.$emit('close', 'borrar-' + this.frecuencia.id);
            },
            borrarFrecuencia() {
                this.loading = true;

                var params = {
                    filters : {},
                    frecuencia_id: this.frecuencia.id,
                    lista_id: this.lista_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.frecuencias.borrar'), params).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
